import React, {
 createContext, useState, useMemo, 
} from 'react';
import PropTypes from 'prop-types';

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [agentId, setAgentId] = useState('');
  const [userId, setUserId] = useState('');
  const [type, setType] = useState('');
  const [currencyType, setCurrencyType] = useState('0');
  const [currencyCode, SetCurrencyCode] = useState('');
  const [countryId, setCountryId] = useState('');

  // This StatusCode state is used to store the status code of the Agent 
  const [statusCode, setStatusCode] = useState('');

  const value = useMemo(() => ({ 
    isLoggedIn, 
    setIsLoggedIn, 
    username, 
    setUsername,
    agentId, 
    setAgentId,
    statusCode, 
    setStatusCode,
    userId,
    setUserId,
    type,
    setType,
    currencyType,
    setCurrencyType,
    SetCurrencyCode,
    currencyCode,
    countryId, 
    setCountryId,
  }), [isLoggedIn, 
    username, 
    agentId, 
    statusCode, userId, type, currencyType, currencyCode, countryId, 
    ]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContextProvider;

